import { effect, inject, Injectable, signal } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { environment } from '../../environments/environment';
import { I18nService } from './i18n-service';
import { MESSAGES, TitleKey } from './messages';

/** What the tab says before anything else on a build that is not production. */
const DEV_TAB = '[DEV] ';

/**
 * Routes carry a key into the catalogue instead of a finished title, so the
 * tab is renamed both on navigation and when the language changes while a
 * page is already open.
 *
 * On dev the title is marked, because a tab is often all there is to tell two
 * open corti.to's apart.
 */
@Injectable()
export class I18nTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);
  private readonly i18n = inject(I18nService);
  private readonly key = signal<TitleKey>('home');

  constructor() {
    super();
    effect(() => {
      const title = this.i18n.t().titles[this.key()];
      this.title.setTitle(environment.dev ? DEV_TAB + title : title);
    });
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const key = this.buildTitle(snapshot);
    this.key.set(isTitleKey(key) ? key : 'home');
  }
}

function isTitleKey(value: string | undefined): value is TitleKey {
  return !!value && value in MESSAGES.es.titles;
}
